import diagnosisApi from '@/api/survey/main';
import { getDignosisData, getValueType } from '@/utils';
import { pull } from 'lodash-es';
import { history } from 'umi';
const ReglementationModel = {
  namespace: 'reglementation',
  state: {
    basicInfo: {
      safeSavingMonthRatio: 0, // 安全储蓄月数系数safe_saving_month_ratio
      maximumDebtRatio: 0, // 最高负债率maximum_debt_ratio
      currentLoanInterestRate: 0, // 当前贷款利率current_loan_interest_rate
      loanTerm: 0, // 借款期限loan_term
      minimumBorrowingCapacityInvestment: 0, // 投资的最低借款能力minimum_borrowing_capacity_investment
    },
    diagnosisFormData: [], // 基础调查表
    leagalFormData: [], // 法务表
  },
  reducers: {
    setDiagnosisFormData(state, action) {
      return {
        ...state,
        diagnosisFormData: action.diagnosisFormData || [],
      };
    },
    setLegalFormData(state, action) {
      return {
        ...state,
        leagalFormData: action.leagalFormData || [],
      };
    },
    setBasicInfo(state, action) {
      return {
        ...state,
        basicInfo: {
          ...action.basicInfo,
          safeSavingMonthRatio: action.basicInfo?.safe_saving_month_ratio || 0, // 安全储蓄月数系数safe_saving_month_ratio
          maximumDebtRatio: action.basicInfo?.maximum_debt_ratio || 0, // 最高负债率
          currentLoanInterestRate:
            action.basicInfo?.current_loan_interest_rate || 0, // 当前贷款利率current_loan_interest_rate
          loanTerm: action.basicInfo?.loan_term || 0, // 借款期限loan_term
          minimumBorrowingCapacityInvestment:
            action.basicInfo?.minimum_borrowing_capacity_investment || 0, // 投资的最低借款能力minimum_borrowing_capacity_investment
        },
      };
    },
    removeDiagnosisFormData(state, action) {
      window.localStorage.removeItem('diagnosisData');
      window.localStorage.removeItem('diagnosisFormDataIsEnd');
      window.localStorage.removeItem('curQuestionId');
      return {
        ...state,
        diagnosisFormData: [],
      };
    },
    removeLegalFormData(state, action) {
      window.localStorage.removeItem('leagalFormData');
      window.localStorage.removeItem('leagalFormDataIsEnd');
      window.localStorage.removeItem('curLeaglFormQuestionId');
      return {
        ...state,
        leagalFormData: [],
      };
    },
  },
  effects: {
    *getFormData({ payload }, { select, call, put }) {
      const isAccept = window.localStorage.getItem('isAccept');
      // 缓存中有值，则直接选择缓存
      let diagnosisData = [];
      let legalFormData = [];
      if (isAccept && isAccept == '1') {
        diagnosisData = getDignosisData('diagnosis');
        legalFormData = getDignosisData('leaglForm');
      }
    },
    *saveDiagnosisFormData({ payload }, { select, call, put }) {
      const isAccept = window.localStorage.getItem('isAccept');
      let answer = [];
      if (isAccept && isAccept == '1') {
        answer = getDignosisData('diagnosis');
      } else {
        const list = yield select(state => state.diagnosis.diagnosisFormData);
        answer = getValueType(list, 'diagnosis');
      }
      try {
        const res = yield call(diagnosisApi.saveDiagnosis, { answer: answer });
        if (res.data.code == 201) {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res);
        }
      } catch (error) {
        return Promise.reject(error);
      }
    },
    *saveLegalFormData({ payload }, { select, call, put }) {
      const isAccept = window.localStorage.getItem('isAccept');
      let answer = [];
      if (isAccept && isAccept == '1') {
        answer = getDignosisData('leaglForm');
      } else {
        const list = yield select(state => state.diagnosis.leagalFormData);
        answer = getValueType(list, 'leaglForm');
      }
      try {
        const res = yield call(diagnosisApi.saveLegal, { answer: answer });
        if (res.data.code == 201) {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res);
        }
      } catch (error) {
        return Promise.reject(error);
      }
    },
    // 保存问卷数据前的判断：未登录情况下先填写问卷->跳转注册、登录接口请求成功后->保存问卷数据
    *onSaveSuveryData({ payload }, { call, put, select }) {
      const isAccept = window.localStorage.getItem('isAccept');
      let dignosisData = [];
      let leaglFormData = [];
      if (isAccept == '1') {
        dignosisData = getDignosisData('diagnosis');
        leaglFormData = getDignosisData('leagalForm');
      } else {
        const diagnosis_list = yield select(
          state => state.diagnosis.diagnosisFormData,
        );
        const leaglForm_list = yield select(
          state => state.diagnosis.leagalFormData,
        );
        dignosisData = getValueType(diagnosis_list, 'diagnosis');
        leaglFormData = getValueType(leaglForm_list, 'leaglForm');
      }
      if (dignosisData.length && leaglFormData.length) {
        try {
          const res = yield call(diagnosisApi.save, {
            diagnosis: dignosisData,
            legal: leaglFormData,
          });
          if (res.data.code == 201) {
            yield put({ type: 'removeDiagnosisFormData' });
            yield put({ type: 'removeLegalFormData' });
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(res);
          }
        } catch (error) {
          return Promise.reject(error);
        }
      }
      return Promise.reject();
    },
  },
};
export default ReglementationModel;
